const Home = () => {
  return (
    <div className="content">
      <div className="container center">
        <h1>SAMPO HOME PLUS AI</h1>
      </div>
    </div>
  );
};

export default Home;
